import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

class HexaText extends React.PureComponent {
  render() {
    const { classes, className, children, ...other } = this.props;
    return (
      <div className={`${classes.hexaText} ${className}`} {...other}>
        <div className={classes.hexaTextContent}> {children}</div>
        <svg viewBox="0 0 100 100" className={classes.hexaTextSvg}>
          <polygon points="50,1 93,25 93,75 50,99 7,75 7,25" className={classes.hexaTextPolygon} />
        </svg>
      </div>
    );
  }
}

HexaText.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
};

export default withStyles(styles)(HexaText);
